import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PoToasterType, PoToasterModule } from '@po-ui/ng-components';
import { ToasterService } from '../../service/toaster.service';
import { AudioService } from '../../service/audio.service';

type AlertConfig = {
  type: PoToasterType;
  duration?: number;
  beepCount?: number;
};

const ALERT_MAP: Record<string, AlertConfig> = {
  error:   { type: PoToasterType.Error, duration: 10000, beepCount: 4 },
  info:    { type: PoToasterType.Information, duration: 3000 },
  success: { type: PoToasterType.Success, duration: 3000 },
  warning: { type: PoToasterType.Warning, duration: 5000, beepCount: 3 },
};

@Component({
  selector: 'app-toaster',
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.css'],
  standalone: true,
  imports: [PoToasterModule]
})
export class ToasterComponent implements OnInit {
  alertMessage: string = '';
  alertType: PoToasterType = PoToasterType.Information;
  hideAlert: boolean = true;

  @Output() alertClosed = new EventEmitter<void>();

  constructor(
    private toasterService: ToasterService,
    private audioService: AudioService
  ) {}

  ngOnInit() {
    this.toasterService.showAlert$.subscribe((alertData) => {
      this.showAlert(alertData.message, alertData.type);
    });
  }

  showAlert(message: string, typeAlert: string) {
    this.alertMessage = message;
    this.hideAlert = false;
    
    const config = ALERT_MAP[typeAlert] ?? { type: PoToasterType.Information };
    this.alertType = config.type;

    if (config.beepCount) {
      this.audioService.playBeep(config.beepCount);
    }

    setTimeout(() => {
      this.hideAlert = true;
      this.alertClosed.emit();
    }, config.duration);
  }
}
